import i18n from "i18next";
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// config
import { HOST_API } from "src/config-global";
//
import { defaultLang, getInitialLang } from "./config-lang";
//
import enCommon from "./en/common.json";
import esCommon from "./es/common.json";
import ptCommon from "./pt/common.json";
import enError from "./en/error.json";
import esError from "./es/error.json";
import ptError from "./pt/error.json";

// ----------------------------------------------------------------------

const lng = getInitialLang();
i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      backends: [
        resourcesToBackend({
          en: {
            common: enCommon,
            error: enError,
          },
          es: {
            common: esCommon,
            error: esError,
          },
          pt: {
            common: ptCommon,
            error: ptError,
          },
        }),
        HttpApi,
      ],
      backendOptions: [
        {},
        {
          loadPath: `${HOST_API}/api/locales/{{lng}}/{{ns}}.json`,
          customHeaders: () => ({
            authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          }),
        },
      ],
    },
    lng,
    fallbackLng: defaultLang.value,
    debug: false,
    ns: ["error", "common"],
    defaultNS: "common",
    interpolation: {
      format: (value, format) => {
        if (value) {
          if (format === "uppercase") return value.toUpperCase();
          if (format === "lowercase") return value.toLowerCase();
        }

        return value;
      },
      escapeValue: false,
    },
  });

export default i18n;
